import React from "react";

const ProductItem = ( { product } ) => {
    if( product ) {
        return (
            <div className="article single-product-loop product-item text-center">
                <a href={`${product.permalink}?ref=Finder`} className="woocommerce-LoopProduct-link woocommerce-loop-product__link">
                    <div className="product-image-wrapper">
                        <img width="1000" height="1000" src={product.thumbnail} className="attachment-large size-large mb-2" alt={product.title} loading="lazy" />
                    </div>
                    <h5 className="h3 font-weight-bold woocommerce-loop-product__title">{product.title}</h5>
                    <div className="info-text">
                        Zu deinen Angaben passt der {product.title} am besten!
                    </div>
                </a>
                <a href={`${product.permalink}?ref=Finder`} className="btn btn-primary btn-lg mt-2" aria-label={`${product.title} ansehen`} rel="nofollow">Ansehen</a>
            </div>
        );
    } else {
        return '';
    }
}

ProductItem.defaultProps = {
    product: {
        permalink: null,
        title: null,
        thumbnail: null,
        id: null,
    }
}

export default ProductItem
